/**
 * @generated SignedSource<<76c2e010a9eedbcc6786e7f08dd690ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MarketingEmailStatus = "DRAFT" | "PARTIALLY_SENT" | "SENDING" | "SENT" | "%future added value";
export type MarketingEmailViewQuery$variables = {
  marketingEmailId: string;
};
export type MarketingEmailViewQuery$data = {
  readonly emailLayouts: ReadonlyArray<{
    readonly emailLayoutIdentifier: string;
    readonly id: string;
    readonly isDefault: boolean;
    readonly name: string;
  }>;
  readonly marketingEmail: {
    readonly archivedAt: any | null | undefined;
    readonly createdAt: any;
    readonly emailTemplate: {
      readonly id: string;
      readonly name: string;
      readonly variants: ReadonlyArray<{
        readonly language: string;
        readonly preheader: string | null | undefined;
        readonly subject: string | null | undefined;
      }>;
    } | null | undefined;
    readonly id: string;
    readonly mailingList: {
      readonly id: string;
      readonly name: string;
      readonly subscribedCount: number;
    } | null | undefined;
    readonly marketingEmailIdentifier: string;
    readonly name: string;
    readonly recipientCount: number;
    readonly replyToEmail: string | null | undefined;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly sentAt: any | null | undefined;
    readonly status: MarketingEmailStatus;
    readonly " $fragmentSpreads": FragmentRefs<"ArchiveMarketingEmailDialog_marketingEmail" | "LaunchMarketingEmailDialog_marketingEmail" | "MarketingEmailDetailsView_marketingEmail" | "SendMarketingEmailTestEmailDialog_marketingEmail">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"MarketingEmailDetailsView_query">;
};
export type MarketingEmailViewQuery = {
  response: MarketingEmailViewQuery$data;
  variables: MarketingEmailViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "marketingEmailId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "marketingEmailId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketingEmailIdentifier",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderEmail",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "replyToEmail",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivedAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscribedCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "EmailTemplateVariant",
  "kind": "LinkedField",
  "name": "variants",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preheader",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "EmailLayout",
  "kind": "LinkedField",
  "name": "emailLayouts",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailLayoutIdentifier",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarketingEmail",
        "kind": "LinkedField",
        "name": "marketingEmail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MailingList",
            "kind": "LinkedField",
            "name": "mailingList",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailTemplate",
            "kind": "LinkedField",
            "name": "emailTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MarketingEmailDetailsView_marketingEmail"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ArchiveMarketingEmailDialog_marketingEmail"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LaunchMarketingEmailDialog_marketingEmail"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SendMarketingEmailTestEmailDialog_marketingEmail"
          }
        ],
        "storageKey": null
      },
      (v15/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "MarketingEmailDetailsView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarketingEmailViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarketingEmail",
        "kind": "LinkedField",
        "name": "marketingEmail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MailingList",
            "kind": "LinkedField",
            "name": "mailingList",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mailingListIdentifier",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailTemplate",
            "kind": "LinkedField",
            "name": "emailTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailTemplateIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryLanguage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EmailLayout",
                "kind": "LinkedField",
                "name": "emailLayout",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v15/*: any*/)
    ]
  },
  "params": {
    "cacheID": "bcffbd8d2d1b232eed99c36dc9417cb0",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailViewQuery",
    "operationKind": "query",
    "text": "query MarketingEmailViewQuery(\n  $marketingEmailId: ID!\n) {\n  marketingEmail(id: $marketingEmailId) {\n    id\n    marketingEmailIdentifier\n    name\n    status\n    senderName\n    senderEmail\n    replyToEmail\n    recipientCount\n    createdAt\n    sentAt\n    archivedAt\n    mailingList {\n      id\n      name\n      subscribedCount\n    }\n    emailTemplate {\n      id\n      name\n      variants {\n        language\n        subject\n        preheader\n      }\n    }\n    ...MarketingEmailDetailsView_marketingEmail\n    ...ArchiveMarketingEmailDialog_marketingEmail\n    ...LaunchMarketingEmailDialog_marketingEmail\n    ...SendMarketingEmailTestEmailDialog_marketingEmail\n  }\n  emailLayouts {\n    id\n    emailLayoutIdentifier\n    name\n    isDefault\n  }\n  ...MarketingEmailDetailsView_query\n}\n\nfragment ArchiveMarketingEmailDialog_marketingEmail on MarketingEmail {\n  id\n  name\n}\n\nfragment LaunchMarketingEmailDialog_marketingEmail on MarketingEmail {\n  id\n  name\n  mailingList {\n    name\n    subscribedCount\n    id\n  }\n  emailTemplate {\n    name\n    id\n  }\n}\n\nfragment MarketingEmailDetailsView_marketingEmail on MarketingEmail {\n  id\n  marketingEmailIdentifier\n  name\n  status\n  senderName\n  senderEmail\n  replyToEmail\n  createdAt\n  sentAt\n  archivedAt\n  mailingList {\n    id\n    mailingListIdentifier\n    name\n    subscribedCount\n  }\n  emailTemplate {\n    id\n    emailTemplateIdentifier\n    name\n    primaryLanguage\n    variants {\n      language\n      subject\n      preheader\n    }\n    emailLayout {\n      id\n      name\n    }\n  }\n}\n\nfragment MarketingEmailDetailsView_query on Query {\n  emailLayouts {\n    id\n    emailLayoutIdentifier\n    name\n    isDefault\n  }\n}\n\nfragment SendMarketingEmailTestEmailDialog_marketingEmail on MarketingEmail {\n  id\n  name\n}\n"
  }
};
})();

(node as any).hash = "8f7de87f458cad55a254c5f2f47b7ccc";

export default node;
